import { ReactNode } from "react";
import "./Endgame.css";
import { clsObj } from "client-util/util";
import { useAccessiblePuzzles } from "stores/ScopeStateStore";
import { Spinner } from "components/Loading";

export function EndgamePiece(props: { puzName: string }) {
  const puzzles = useAccessiblePuzzles();
  if (!puzzles) return <Spinner />;
  const displayName = puzzles[props.puzName].displayName;
  const roundId = Object.values(puzzles).find(
    (puz) => puz.displayName === displayName && puz.roundId !== "endgame"
  )?.roundId;
  if (!roundId) {
    throw new Error(`no round id found for ${displayName}`);
  }

  return (
    <div
      className={clsObj({
        [`endgame-${roundId}`]: !!roundId,
        "endgame-piece": true,
      })}
    >
      <div
        style={{
          fontSize:
            displayName.length > 30 ||
            displayName.split(" ").some((w) => w.length > 12)
              ? "0.7em"
              : undefined,
          textShadow: "0 0 0.17em #000c",
          margin: "0.5em",
        }}
      >
        {displayName}
      </div>
    </div>
  );
}

export function EndgameCorner(props: {
  left: boolean;
  right: boolean;
  thin: boolean;
  thick: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={clsObj({
        "endgame-corner": true,
        "text-left": props.left,
        "text-right": props.right,
        "piece-thin": props.thin,
        "piece-thick": props.thick,
      })}
    >
      {props.children}
    </div>
  );
}

export function EndgameSolutionGrid(props: { grid: Record<string, string[]> }) {
  return (
    <div
      className={clsObj({
        "endgame-solution-grid": true,
      })}
    >
      {Object.entries(props.grid).flatMap(([round, coords]) => {
        return coords.map((coord) => {
          const [, r, c] = /R(\d+)C(\d+)/.exec(coord)!;
          return (
            <div
              key={coord}
              className={`piece-view`}
              style={{
                position: "absolute",
                top: `${((Number(r) - 1) / 10) * 100}%`,
                left: `${((Number(c) - 1) / 11) * 100}%`,
              }}
            >
              <div className={`endgame-${round}`} />
            </div>
          );
        });
      })}
    </div>
  );
}
